<template>
	<div class="c-product__costs">
		<template v-if="isLoggedIn">
			<template v-if="pricePromo != 0">
				<div class="c-product__price">
					<span class="c-product__price--price"> {{ pricePromo | toCurrency}}</span>
					<span class="c-product__price--yourprice">jouw prijs</span>
				</div>
				<div class="c-product__brutoprice text-muted">{{ price | toCurrency }} bruto prijs excl. BTW</div>
			</template>
			<template v-else>
				<div class="c-product__price">
					<span class="c-product__price--price">{{ price | toCurrency }}</span>
					<span class="c-product__price--yourprice text-muted">Brutoprijs excl. BTW</span>
				</div>
			</template>
		</template>
		<template v-else>
			<div class="c-product__price">
				<span class="c-product__price--price" data-tooltip="Log in voor jouw prijs">{{ price | toCurrency }} </span>
				<span class="c-product__price--yourprice text-muted">Brutoprijs excl. BTW</span>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		isLoggedIn: {
			type: Boolean,
			required: true
		},
		pricePromo: {
			type: Number,
			default: 0
		},
		price: {
			type: Number,
			required: true
		}
	}
};
</script>
